import React, {useState} from 'react';
import {toast, ToastContainer} from "react-toastify";
import CustomDataTable from "../CustomDataTable";
import $ from "jquery";
import {trans} from "../../utils";

const Actions = ({data,sendRequest,params}) => {
    const [action, setAction] = useState({
        action:'',
    });
    const handleActionsChange = event =>{
        setAction({...action,action: event.target.value} );
    }
    const handleActionsForm = event =>
    {
        event.preventDefault();
        sendRequest(action,"WorkOrderAction",function (){
            $("#WorkOrderAction").DataTable().ajax.reload()
            setAction({
                action:'',
            })
        })
    }
    const ActionOptionColumns = [
        {data:"id",title:""},
        {data:"created_at",title:"Date"},
        {data:"created_by_user.name",title:"Done By"},
        {data:"notes_to_assignee",title:"Notes"},
        {data:"assignee.name",title:"Assign to"},
        {data:"Action",title:"Action"},
    ]
    const ActionColumns = [
        {data:"id",title:"#"},
        {data:"created_at",title:"Date"},
        {data:"created_by_user.name",title:"Done By"},
        {data:"action",title:"Action"},
    ]

    return(
       <>
            <div className="card-header cursor-pointer">
                <div className="card-title m-0">
                    <h3 className="fw-bolder m-0">{trans('Action Options')}</h3>
                </div>
            </div>
            <div className="card-body p-9">
                <CustomDataTable columns={ActionOptionColumns} url={"WorkOrderActionOption?wo_id="+params.id+"&include=created_by_user,assignee"} table_id="WorkOrderActionOption" />

            </div>

           <div className="card-header cursor-pointer">
               <div className="card-title m-0">
                   <h3 className="fw-bolder m-0">{trans('Actions')}</h3>
               </div>
               { data.status_data  &&
               data.status_data.title_en == "Active" && (data.is_assignee || data.is_admin) &&
               <div className="d-flex my-4">
                   <button type="button" className="btn btn btn-light-primary waves-effect waves-light" data-toggle="modal" data-target="#ActionModal">
                       <i className="bi bi-plus fs-3"></i> {trans('Add a new actions')}
                   </button>
               </div>}
           </div>
           <div className="modal fade" id="ActionModal" tabIndex="-1" role="dialog"
                aria-labelledby="ActionModalLabel" aria-hidden="true">
               <div className="modal-dialog" role="document">
                   <div className="modal-content">
                       <div className="modal-header">
                           <h5 className="modal-title" id="exampleModalLabel">{trans('Add a new action')}</h5>
                           <button type="button" className="close" data-dismiss="modal"
                                   aria-label="Close">
                               <span aria-hidden="true">&times;</span>
                           </button>
                       </div>
                       <form onSubmit={handleActionsForm}>

                           <div className="modal-body">

                               <div className="form-group">
                                   <label htmlFor="message-text"
                                          className="col-form-label">{trans('Actions')} :</label>
                                   <input
                                       className="form-control"
                                       type="text" name="actions"  value={action.action}
                                       onChange={handleActionsChange}
                                       autoFocus required />
                               </div>
                           </div>
                           <div className="modal-footer">
                               <button type="button" className="btn btn-secondary"
                                       data-dismiss="modal">{trans('Close')}
                               </button>
                               <button className="btn btn-primary" onClick={handleActionsForm} type="submit" data-dismiss="modal" >{trans('Submit')}</button>
                           </div>
                       </form>
                   </div>
               </div>
           </div>
           <div className="card-body p-9">
               <CustomDataTable columns={ActionColumns} url={"WorkOrderAction?wo_id="+params.id+"&include=created_by_user"} table_id="WorkOrderAction" />
           </div>
        </>
    )

}
export default Actions
